<script>
import TwCard from '../../generic/tw-card.vue'
import TwCheckbox from '../../generic/forms/tw-checkbox.vue'
import TwButton from '../../generic/tw-button.vue'

export default {
  name: 'DonateTakeCareOfFeesCard',
  components: { TwButton, TwCheckbox, TwCard },
  props: {
    modelValue: {
      type: Boolean,
      default: true
    },
    donationStripeFeeOffsetAmount: {
      type: Number,
      default: 0
    },
    currency: {
      type: String,
      default: 'USD'
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      Expanded: false,
    }
  }
}
</script>

<template>
  <tw-card class="bg-amber-50">
    <span class="text-sm"> + {{ $filters.formatCurrency(donationStripeFeeOffsetAmount, currency) }} to cover credit card processing fees.</span> <tw-button variant="link" class="text-amber-800" size="sm" @click="Expanded = !Expanded">
      {{ Expanded? 'Done':'Change' }} <icon icon="chevron-right" :class="[Expanded? 'rotate-90':'', 'transition-transform ml-0']" />
    </tw-button>
    <div v-if="Expanded">
      <div class="text-xs my-2">
        Payment processors charge a fee for processing credit card payments. By opting in to cover these fees, you can help ensure that more of your donation goes directly to the cause you care about. Thank you for your generosity!
      </div>
      <tw-checkbox :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
        Yes, I want to cover the the credit card fees <span v-if="donationStripeFeeOffsetAmount > 0">(+{{ $filters.formatCurrency(donationStripeFeeOffsetAmount, currency) }})</span>
      </tw-checkbox>
    </div>
  </tw-card>
</template>

<style scoped>

</style>
